export default __webpack_public_path__ + "static/media/pincho.c7e9af7e.svg";